import { getCookie } from '@/utils/cookie';
import axios from 'axios';

const instance = axios.create({
    timeout: 20000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

instance.interceptors.request.use(
    config => {
        config.headers.Authorization = getCookie() || '';
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    res => {
        return res.data;
    },
    res => {
        if (res.response) {
            return Promise.reject(res.response);
        }
        return Promise.reject(res);
    }
);

export const get = (url, params) => {
    return new Promise((resolve, reject) =>
        instance
            .get(url, { params })
            .then(res => {
                if (res.code != 200) {
                    reject(res);
                } else {
                    resolve(res);
                }
            })
            .catch(e => {
                reject(e);
            })
    );
};

export const post = (url, params) => {
    return new Promise((resolve, reject) =>
        instance
            .post(url, params)
            .then(res => {
                if (res.code != 200) {
                    reject(res);
                } else {
                    resolve(res);
                }
            })
            .catch(e => {
                reject(e);
            })
    );
};

export const postJson = (url, params) => {
    return new Promise((resolve, reject) =>
        instance
            .post(url, params, { headers: { 'Content-type': 'application/json; charset=utf-8' } })
            .then(res => {
                if (res.code != 200) {
                    reject(res);
                } else {
                    resolve(res);
                }
            })
            .catch(e => {
                reject(e);
            })
    );
};

export const postFile = (url, data) => {
    return new Promise((resolve, reject) =>
        instance
            .post(url, data, { headers: { 'Content-type': 'multipart/form-data' } })
            .then(res => {
                if (res.code != 200) {
                    reject(res);
                } else {
                    resolve(res);
                }
            })
            .catch(e => {
                reject(e);
            })
    );
};
